import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  IntroductionPayload,
  IdentificationPayload,
  DeliverOtpPayload,
  VerifyOtpPayload,
  ConfirmationPayload,
} from './types';
import { apiClient } from '@/utils/apiClient';

export const postIntroduction = createAsyncThunk(
  'registration/postIntroduction',
  async (payload: IntroductionPayload) => {
    const response = await apiClient('/auth/api/v1/signup/introduction/', {
      method: 'POST',
      body: payload,
    });
    return response;
  }
);

export const fetchIdentifications = createAsyncThunk(
  'registration/fetchIdentifications',
  async (session_id: string) => {
    const response = await apiClient('/auth/api/v1/signup/identifications/', {
      method: 'POST',
      body: { session_id },
    });
    return response;
  }
);

export const submitIdentifications = createAsyncThunk(
  'registration/submitIdentifications',
  async (payload: IdentificationPayload) => {
    const response = await apiClient(
      '/auth/api/v1/signup/identifications/submit/',
      {
        method: 'POST',
        body: payload,
      }
    );
    return response;
  }
);

export const deliverOtp = createAsyncThunk(
  'registration/deliverOtp',
  async (payload: DeliverOtpPayload) => {
    const response = await apiClient('/auth/api/v1/signup/otp/', {
      method: 'POST',
      body: payload,
    });
    return response;
  }
);

export const verifyOtp = createAsyncThunk(
  'registration/verifyOtp',
  async (payload: VerifyOtpPayload) => {
    const response = await apiClient('/auth/api/v1/signup/verification/', {
      method: 'POST',
      body: payload,
    });
    return response;
  }
);

export const confirmAccount = createAsyncThunk(
  'registration/confirmAccount',
  async (payload: ConfirmationPayload) => {
    const response = await apiClient('/auth/api/v1/signup/confirmation/', {
      method: 'POST',
      body: payload,
    });
    return response;
  }
);
